import React from "react";

const HeroC = ({ titulo, imagen, cards = [], modo = "texto", botonTexto }) => {
  return (
    <section className="w-full bg-[#E8F2F4] py-16 lg:pb-32 px-4 sm:px-6">
      <div className="w-full bg-[#0346A4] flex flex-col lg:flex-row justify-center items-center gap-10 py-12 sm:py-16 px-4 sm:px-8 lg:px-16 rounded-[40px]">
        <div className="w-full lg:w-2/5 relative z-10 flex justify-center items-center">
          <img
            src={imagen}
            alt={titulo}
            className="rounded-2xl object-cover w-full max-w-sm sm:max-w-md h-72 sm:h-96 lg:h-[600px]"
          />
        </div>
        <div className="w-full lg:w-3/5 flex flex-col items-center text-white">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-10 text-center leading-snug">
            {titulo}
          </h2>
          <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
            {cards.map((card, idx) => (
              <div
                key={idx}
                className={`bg-[#E8F2F4] text-[#02357c] font-bold ${
                  modo === "texto"
                    ? "px-10 py-16 md:px-12 md:py-20"
                    : "px-6 py-8"
                } rounded-[60px] md:rounded-[120px] min-h-[260px] z-40 text-center shadow-[0_10px_16px_rgba(0,0,0,0.4)] flex flex-col justify-center`}
              >
                {modo === "texto" ? (
                  <>
                    <h3 className="text-[#0346A4] text-2xl sm:text-3xl mb-6">
                      {card.title}
                    </h3>
                    <p className="text-lg sm:text-2xl text-[#0054C9]">
                      {card.text}
                    </p>
                  </>
                ) : (
                  <div className="z-60">
                    <h3 className="text-[#0346A4] text-2xl mb-2">
                      {card.nombre}
                    </h3>
                    <p className="text-lg text-[#0054C9]">{card.rol}</p>
                    {card.foto ? (
                      <img
                        src={card.foto}
                        alt={card.nombre}
                        className="w-40 h-40 sm:w-48 sm:h-48 rounded-full mx-auto mt-4 object-cover object-top"
                      />
                    ) : (
                      <div className="w-20 h-20 sm:w-24 sm:h-24 bg-yellow-300 rounded-full mx-auto mt-4" />
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
          {botonTexto && (
            <button className="bg-[#276AE8] text-white font-bold py-3 px-10 rounded-full shadow-md hover:bg-[#3689ff] transition w-full max-w-[300px] text-lg">
              {botonTexto}
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroC;
